// The one sign-in session (@jkast90/kast-common/auth): the tokens from
// login.kast-dev.net under the auth_* keys, refreshed before they expire and
// once on a 401, revoked on sign-out.
//
// Created at import, before anything renders or reads the cache: a sign-in
// landing in the URL hash is taken (and scrubbed) first, so nothing reads the
// previous person's tokens or data in the meantime.

import {
  createSession,
  localStorageTokenStore,
  redirectToSignIn,
  takeTokensFromUrl,
} from "@jkast90/kast-common/auth";
import { getCognitoClientId, getCognitoDomain } from "../settings";

export const session = createSession({
  cognitoDomain: getCognitoDomain(),
  clientId: getCognitoClientId(),
  // lastVisitedRoute is the old return path; the module keeps its own now.
  store: localStorageTokenStore({
    alsoClear: ["userEmail", "lastVisitedRoute"],
  }),
});

const taken = takeTokensFromUrl(session);
if (taken?.returnTo) window.history.replaceState(null, "", taken.returnTo);

/**
 * Where a sign-in started here comes back to: this page, except a sign-out
 * landing (`?_logout=true`), which would send the next sign-in back into the
 * sign-out, and the old /auth callback.
 */
export function returnPath(): string {
  const { pathname, search } = window.location;
  if (search.includes("_logout=true") || pathname.startsWith("/auth"))
    return "/";
  return pathname + search;
}

/** Go to the login site, coming back to this page. */
export function startSignIn(): void {
  redirectToSignIn({ returnTo: returnPath() });
}
